<template>
	<div class="gs">
		<van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="list">
			<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
				<div class="gsc">
					<div class="gst-head">
						<div class="gsth-item t1">公示事项</div>
						<div class="gsth-item t2">公示时间</div>
						<div class="gsth-item t3">状态</div>
						<!-- <div class="gsth-item t4">投票情况</div> -->
						<div class="gsth-item t5">操作</div>
					</div>
					<div class="gst-body">
						<div class="gstb-row" v-for="(item, index) in jcList" :key="index">
							<div class="gstb-item t1">
								 {{ item.title | ellipisdata }}
							</div>
							<div class="gstb-item t2">{{ item.publishDate }}</div>
							<div class="gstb-item t3">{{ item.finalResult }}</div>
							<div class="gstb-item t5" @click="handleClick(item.id)">
								详情
							</div>
						</div>
					</div>
				</div>
			</van-list>
		</van-pull-refresh>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				jcList: [
				/* 	{
					title:'q1eqwfsvcsjn',
					publishDate:'2rrwreqwqr',
					finalResult:'q12r',
				}, */
				],
				loading: false,
				finished: false,
				refreshing: false,
				pageNum: 0,
			};
		},
		mounted() {},
		filters: {
			ellipisdata: function(str) {
				if (str.length > 6) {
					return str.substring(0,6) + "..."
				} else {
					return str
				}
			}
		},
		methods: {
			onRefresh() {
				this.finished = false;
				// 重新加载数据
				// 将 loading 设置为 true，表示处于加载状态
				this.loading = true;
				this.onLoad();
			},
			onLoad() {
				if (this.refreshing) {
					// 清空列表数据
					this.pageNum=0;
					this.jcList = [];
					this.refreshing = false;
				}
				this.$axios.get('/api/v1/wechat/yzjc/gsgl', {
					params: {
						pageNum: this.pageNum,
						pageSize: 15
					}
				}).then(res => {
					this.jcList.push(...res.data);
					this.pageNum++;
					this.loading = false;
					if (this.jcList.length >= res.total) {
						this.finished = true;
					}
				});
			},
			handleClick(id) {
				this.$router.push({
					path: "/yzjc/gsdet",
					query: {
						id: id
					},
				});
			},
		},
	};
</script>
<style lang="less">
	.gs {
		width: 100%;

		.gsc {
			margin: 10px;
			background-color: #ffffff;
			box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.1);
			border-radius: 5px;

			.gst-head {
				width: 98%;
				height: 32px;
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px solid #f4f4f4;
				margin: 0 auto;

				.gsth-item {
					width: 25%;
					height: 32px;
					text-align: center;
					line-height: 32px;
					color: #2a2a2a;
					font-size: 15px;
				}

				.t1 {
					width: 28%;
				}

				.t2 {
					flex:1;
				}

				.t3 {
					width: 15%;
				}

				.t5 {
					width: 15%;
				}
			}

			.gst-body {
				width: 98%;
				//   height: 32px;
				margin: 0 auto;

				.gstb-row {
					width: 100%;
					height: 32px;
					display: flex;
					flex-direction: row;
					justify-content: space-between;
					align-items: center;
					border-bottom: 1px solid #f4f4f4;

					.gstb-item {
						height: 32px;
						text-align: center;
						line-height: 32px;
						color: #777777;
						font-size: 13px;
					}

					.t1 {
						width: 28%;
					}

					.t2 {
						flex:1;
					}

					.t3 {
						width: 15%;
					}

				/* 	.t4 {
						width: 19%;
					} */

					.t5 {
						width: 15%;
						color: #40b2ed;
					}
				}
			}

		}
	}
</style>
